import React, { Component } from 'react';
import { ButtonToolbar, FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import ToggleButtonGroup from 'react-bootstrap/lib/ToggleButtonGroup'
import ToggleButton from 'react-bootstrap/lib/ToggleButton'

class StringIO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      outputValue: '',
      errorValue: '',
      decode: 'encode',
      format: 'uri',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDecodeChange = this.handleDecodeChange.bind(this);
    this.handleFormatChange = this.handleFormatChange.bind(this);
    this.updateErrorOutput = this.updateErrorOutput.bind(this);
    this.getFormat = this.getFormat.bind(this);
  }

  getFormat(format) {
    let return_obj = {}
    switch (format) {
      case 'uri':
        console.log('returning URI')
        return_obj = (decode, str) => {
          let result = '';
          try {
            result = decode === 'decode' ? decodeURIComponent(str.replace(/\+/g,  " ")) : encodeURI(str);
          } catch (e) {
            this.updateErrorOutput(e)
            result = ''
          }
          return result;
        };
        break;
      case 'base64':
      console.log('returning BASE')
        return_obj = (decode, str) => {
          let result = ''
          try {
            result = decode === 'decode' ? window.atob(str) : window.btoa(str); return result;
          } catch (e) {
            this.updateErrorOutput(e)
            result = '';
          }
          return result;
        };
        break;
      default:
        console.log('fail');
    }
    return return_obj;
  }

  updateErrorOutput(event) {
    this.setState({errorValue: event.stack})
  }

  handleInputChange(event) {
    this.setState({inputValue: event.target.value});
    this.setState({errorValue: ''});
    this.setState({outputValue: this.getFormat(this.state.format)(this.state.decode, event.target.value)});
    // this.setState({outputValue: this.updateInputString(event.target.value, this.state.decode)});
  }

  handleFormatChange(event) {
    this.setState({format: event});
    this.setState({errorValue: ''});
    this.setState({outputValue: this.getFormat(event)(this.state.decode, this.state.inputValue)});
  }

  handleDecodeChange(event) {
    this.setState({decode: event});
    this.setState({errorValue: ''});
    this.setState({outputValue: this.getFormat(this.state.format)(event, this.state.inputValue)});
    // this.setState({output_value: this.updateInputString(this.state.input_value, event)});
  }


  render() {
    return (
      <div>
        {this.props.children}
        <form onSubmit={this.handleSubmit}>
          <FormGroup controlId="formControlsTextarea" className="top-buffer">
            <ControlLabel>Input</ControlLabel>
            <ButtonToolbar className="top-buffer">
              <ToggleButtonGroup onChange={this.handleFormatChange} name="format" type="radio" defaultValue={this.state.format} >
                <ToggleButton value={'uri'}>URL</ToggleButton>
                <ToggleButton value={'base64'}>Base64</ToggleButton>
              </ToggleButtonGroup>
            </ButtonToolbar>
            <FormControl  className="top-buffer" onChange={this.handleInputChange} componentClass="textarea" placeholder="String Input" />
          </FormGroup>
        </form>
        <FormGroup controlId="formControlsTextarea" className="top-buffer">
          <ControlLabel>Output</ControlLabel>
          <ButtonToolbar className="top-buffer">
            <ToggleButtonGroup onChange={this.handleDecodeChange} type="radio" name="encode" defaultValue={this.state.decode}>
              <ToggleButton value={'encode'}>Encode</ToggleButton>
              <ToggleButton value={'decode'}>Decode</ToggleButton>
            </ToggleButtonGroup>
          </ButtonToolbar>

          <FormControl  className="top-buffer" value={this.state.outputValue} componentClass="textarea" placeholder="String Output" />
        </FormGroup>
        {this.state.errorValue !== '' ?
          <FormGroup controlId="formControlsTextarea" className="top-buffer">
            <ControlLabel>Error</ControlLabel>
            <div className="error-box s">
              <code>{this.state.errorValue}</code>
            </div>
          </FormGroup>
        : '' }
      </div>
    );
  }
}

export default StringIO;



// WEBPACK FOOTER //
// ./src/components/StringIO/StringIO.js